<template>
    <v-card color="secondary" dark>
        <v-card-text>
            Bei einem Kauf von mindestens {{event.discount_threshold}} Tickets erhalten Sie {{event.rendered_discount_amount}} Rabatt.
        </v-card-text>
    </v-card>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "MultiTicketInfoBox",
        computed: {
            ...mapState('form', [
                    'event',
                    'priceDetails',
                ]
            ),
        }
    }
</script>

<style scoped>

</style>